<template>
  <article class="analysisA dcc-follow-up">
    <ul class="tab-service-detail">
      <li v-for="item in tabList" @click="onShiftTab(item)" :class="{on:item.on}" :key="item.id">
        <a href="javascript:void(0);">{{ item.name }}</a>
      </li>
    </ul>
    <div class="blank"></div>
    <div class="car-all">
      <cell title="DCC专员" class="top-title" v-if="this.tabList[0].on && this.tabList[0].id === 'date'">
        <span slot="after-title" class="title-date">{{"|&nbsp;&nbsp;" + day }}</span>
        <button
          slot="child"
          :class="{'btn-select': flagA, 'btn-default': !flagA}"
          @click="onChangeTab({filter: 'today', bool: true})"
        >
          今天
        </button>
        <button
          slot="child"
          :class="[{'btn-select': !flagA, 'btn-default': flagA}, 'btn-margin']"
          @click="onChangeTab({filter: 'yestoday', bool: false})"
        >
          昨天
        </button>
      </cell>
      <cell title="DCC专员" class="top-title" v-else>
        <span slot="after-title" class="title-date">{{"|&nbsp;&nbsp;" + day }}</span>
        <button
          slot="child"
          :class="{'btn-select': flagA, 'btn-default': !flagA}"
          @click="onChangeTab({filter: 'this_month', bool: true})"
        >
          本月
        </button>
        <button
          slot="child"
          :class="[{'btn-select': !flagA, 'btn-default': flagA}, 'btn-margin']"
          @click="onChangeTab({filter: 'last_month', bool: false})"
        >
          上个月
        </button>
      </cell>
      <p class="table-title">跟进概况</p>
      <a-card
        v-if="this.tabList[0].on && this.tabList[0].id === 'date'"
        ref="allClues"
        config="allClues"
        first-field="dcc"
        :is-scroll="true"
        :params="params"
      >
        <th slot="title">DCC专员</th>
      </a-card>
      <a-card
        v-else
        ref="allClues"
        config="allClues"
        first-field="dcc"
        :isNotContacted="true"
        :is-scroll="true"
        :params="params"
      >
        <th slot="title">DCC专员</th>
      </a-card>
      <template v-if="this.tabList[0].on && this.tabList[0].id === 'date'">
        <p class="table-title">待跟进</p>
        <a-card
          ref="dccClueFollowUp"
          config="dccClueFollowUp"
          first-field="dcc"
          :is-scroll="true"
          :params="{store_id: storeId}"
        >
          <th slot="title">DCC专员</th>
        </a-card>
      </template>
      <div class="funnel-analysis" v-else>
        <p class="table-title">DCC专员营销漏斗分析 </p>
        <div>
          <div class="tabs box">
            <checker default-item-class="checker" selected-item-class="checker-selected" v-model="dccValue">
              <checker-item
                value=""
                key=""
                @on-item-click="onChangeChecker()"
              >
                全部
              </checker-item>
              <checker-item
                v-for="(item, index) in dccAllList"
                :value="item.id" :key="index"
                @on-item-click="onChangeChecker(item)"
              >
                {{ item.name }}
              </checker-item>
            </checker>
          </div>
          <group class="diagram-analysis-dl">
            <cell class="one">
              <p slot="after-title">
                <span>线索合计</span>
                <em class="p-em">{{ DccFunnelData.clue }}</em>
                <span></span>
              </p>
            </cell>
            <cell class="two">
              <p slot="after-title">
                <span>到店合计</span>
                <em class="p-em">{{ DccFunnelData.arrived }}</em>
                <span>&nbsp;&nbsp;到店率：{{ DccFunnelData.arrived_rate * 100 }}%</span>
              </p>
            </cell>
            <cell class="three">
              <p slot="after-title">
                <span>成交合计</span>
                <em class="p-em">{{ DccFunnelData.deal }}</em>
                <span class="deal-rate rates">
                  &nbsp;&nbsp;&nbsp;&nbsp;成交率：{{ DccFunnelData.deal_rate * 100 }}%
                  <br>&nbsp;&nbsp;&nbsp;&nbsp;到店成交率：{{ DccFunnelData.arrived_to_deal_rate * 100 }}%
                </span>
              </p>
            </cell>
          </group>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import util from '../../common/util'
import ACard from './components/ACard'

import {
  Cell,
  Checker,
  CheckerItem,
  Group
} from '@lx-frontend/cvux'

export default {
  components: {
    Cell,
    Checker,
    CheckerItem,
    Group,
    ACard
  },
  data () {
    return {
      storeId: this.$route.query.store_id,
      flagA: true,
      day: util.formatTime(new Date(), 'yyyy-MM'), // 获取当前日期
      params: {
        filter: 'this_month',
        store_id: this.$route.query.store_id
      },
      tabList: [{
        id: 'date',
        name: '日',
        on: false
      }, {
        id: 'month',
        name: '月',
        on: true
      }],
      dccValue: '', // 设置选中默认值为全部
      dccAllList: [], // 所有的DCC
      DccFunnelData: {} // DCC专员营销漏斗分析
    }
  },
  created () {
    this.queryDccs() // 所有的销售顾问
    this.queryDccFunnel('') // DCC专员营销漏斗分析
    this.getType()
  },
  methods: {
    getType () {
      const type = this.$route.query.type
      let index = 1

      if (type) {
        index = parseFloat(type)
      }

      this.onShiftTab(this.tabList[index])
    },
    getData () {
      if (this.$refs.allClues) {
        this.$refs.allClues.query('allClues', this.params)
      }
      if (this.$refs.dccClueFollowUp) {
        this.$refs.dccClueFollowUp.query('dccClueFollowUp', {
          store_id: this.storeId
        })
      }
      this.queryDccs()
      this.queryDccFunnel('')
    },
    getCurrentTime () {
      let date = new Date()
      switch (this.params.filter) {
        case 'last_month':
          let lastMonty = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate())
          this.day = util.formatTime(lastMonty, 'yyyy-MM')
          break
        case 'yestoday':
          let yesterday = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1)
          this.day = util.formatTime(yesterday, 'yyyy-MM-dd')
          break
        case 'today':
          this.day = util.formatTime(date, 'yyyy-MM-dd')
          break
        default:
          this.day = util.formatTime(date, 'yyyy-MM')
      }
    },
    onShiftTab(item) {
      this.tabList.forEach((tab) => {
        if (item.id === tab.id) {
          tab.on = true
        } else {
          tab.on = false
        }
      })
      this.flagA = true
      if (item.on && item.id === 'date') {
        this.params.filter = 'today'
      } else {
        this.params.filter = 'this_month'
      }

      this.getData()
      this.getCurrentTime()
    },
    onChangeTab(params) {
      this.flagA = params.bool
      this.params.filter = params.filter
      this.getData()
      this.getCurrentTime()
    },
    onChangeChecker (item) {
      if (item) {
        this.queryDccFunnel(item.id)
      } else {
        this.queryDccFunnel('')
      }
    },
    // DCC专员营销漏斗分析
    queryDccFunnel (dccId) {
      let params = {
        filter: this.params.filter,
        dcc: dccId,
        store_id: this.storeId
      }
      this.$rest.dataAnalysis.getDccFunnel(params).then(res => {
        if (res.code === 0) {
          this.DccFunnelData = res.data
        }
      })
    },
    // 所有的DCC
    queryDccs () {
      let params = {
        store_id: this.storeId
      }
      this.$rest.dataAnalysis.getDccs(params).then(res => {
        if (res.code === 0) {
          this.dccAllList = res.data
        }
      })
    }
  }
}
</script>

<style lang="less">
  @import "../../stylesheets/modules/data/carData.less";
  @import "../../stylesheets/modules/data/funnelAnalysis.less";
  .dcc-follow-up {
    .rates {
      width: 3.5rem;
      display: inline-block;
      margin-left: -0.1rem
    }
    .first-to-shop {
      layout-flow:vertical-ideographic
    }
    .diagram-analysis-dl{
      .weui_cells{
        margin-top: -10/@w2;
        &::before{
          display: none;
        }
        &::after{
          left: 30/@w2;
        }
      }
      .weui_cell{
        padding: 0 0 0 0.4rem;
        &::before{
          z-index: 11;
        }
      }

      .one em.p-em{
        margin-left: 0;
      }
      .two em.p-em{
        margin-left: 16/@w2;
      }
      .three em.p-em{
        margin-left: 32/@w2;
      }
      em{
        font-size: 26/@w2;
        text-align: center;
        position: relative;
        &:before,&:after{
          content: "";
          position: absolute;
          background: url("../../stylesheets/images/manage/triangle.png") no-repeat;
          width: 16/@w2;
          height:96/@w2;
          background-size:100% 100%;
          top:0;
        }
        &:before{
          left: 0;
        }
        &:after{
          right: 0;
          -webkit-transform: scale(-1,1);
        }
      }

      .title{
        em,span {
          color: #5b6984;
        }
        span{
          display: inline-block; width: 158/@w2;
        }
      }
      .one {
        em{ background: #d7e3ff; display: inline-block; width: 283/@w2;
          margin-left: 0 }
      }
      .two {
        em{ background: #e3ebff; display: inline-block; width: 251/@w2;
          margin-left: 16/@w2;}
      }
      .three {
        em{ background: #f3f6ff; display: inline-block; width: 219/@w2;
          margin-left: 70/@w2;}
      }
      .deal-rate {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        line-height: normal;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p > span{
        &:nth-child(1){
          display: inline-block;
          width: 158/@w2;
          text-indent: 30/@w2;
          color: #5b6984;
        }
        &:first-child, &:last-child {
          font-size: 26/@w2;
        }
      }
      span,em{ float: left;line-height: 96/@w2;}
      em{width: 234/@w2; line-height: 96/@w2;
        position: relative;}
      .weui_cell {
        padding: 0;
        margin-right: 30/@w2;
        border-bottom: 1px solid #D9D9D9;
      }
      .weui_cell:before {
        left: 0;
        border-top: 0;
      }
    }
  }

</style>
